import { Box } from "@mui/material";
import { UserCircle } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SidenavFooterButton from "./SidenavFooterButton";

export default function AccountButton({ handleToggle }: { handleToggle?: () => void }) {
  const active = ["/account", "/subscription"].includes(window.location.pathname);
  const { t } = useTranslation();

  return (
    <Box
      component={Link}
      to={"/account"}
      onClick={handleToggle}
      className={active ? "active" : ""}
      sx={{
        textDecoration: "none",
        color: "black",
        "&.active": { bgcolor: "primary.light", color: "primary.main" },
      }}
    >
      <SidenavFooterButton Icon={UserCircle} children={t("nav.account")} />
    </Box>
  );
}
